// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalForm_wrapper__frWfl","title":"ModalForm_title__k7U+u","description":"ModalForm_description__Qdoub"};